import { createContext, useContext, useEffect, useMemo } from "react";
import type { Theme } from "@web/src/hooks/useThemePreference";
import { useThemePreference } from "@web/src/hooks/useThemePreference";

const ThemeContext = createContext<{
  theme: Theme;
  preferredTheme: Theme | undefined;
  setTheme: (theme: Theme | undefined) => void;
}>({
  theme: "light",
  preferredTheme: undefined,
  setTheme: () => {},
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme, setTheme, preferredTheme } = useThemePreference();
  const context = useMemo(() => ({ theme, setTheme, preferredTheme }), [theme, setTheme, preferredTheme]);
  return <ThemeContext.Provider value={context}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const context = useContext(ThemeContext);
  return context.theme;
}

export function useThemeContext() {
  const context = useContext(ThemeContext);
  return context;
}
